import { defineConstants } from "@p-ban/common/src/constants/defineConstants"

const REQUEST_CONTENTS = defineConstants([
  { label: "見積・注文方法", value: "HowToEstimateOrder", sort: 1 },
  { label: "基板の作り方の注意点", value: "ImportantPoint", sort: 2 },
  { label: "P板.comを使うメリット", value: "Advantages", sort: 3 },
  { label: "品質面", value: "Quality", sort: 4 },
  { label: "コストダウンできる手法", value: "CostReduction", sort: 5 },
  { label: "各種サービス（設計、製造、実装、筐体・パーツ製造）の概要", value: "OverviewOfVariousServices", sort: 6 },
] as const)

export default REQUEST_CONTENTS
